import React from "react";
import * as Icon from "react-feather";
import GmailService from "../../services/GmailService";

function formatBytes(n) {
	if (!n) return "";
	if (n < 1024) return `${n} B`;
	if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
	return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

function pickIcon(mimeType) {
	if (!mimeType) return Icon.File;
	if (mimeType.startsWith("image/")) return Icon.Image;
	if (mimeType.startsWith("video/")) return Icon.Film;
	if (mimeType.startsWith("audio/")) return Icon.Music;
	if (mimeType.includes("pdf")) return Icon.FileText;
	if (mimeType.includes("zip") || mimeType.includes("compressed")) return Icon.Archive;
	if (mimeType.includes("spreadsheet") || mimeType.includes("excel") || mimeType.includes("csv")) return Icon.Grid;
	if (mimeType.includes("word") || mimeType.includes("document")) return Icon.FileText;
	return Icon.File;
}

const AttachmentChip = ({ accountId, attachment }) => {
	const IconCmp = pickIcon(attachment.mimeType);
	const url = GmailService.attachmentUrl({
		accountId,
		messageId: attachment.messageId,
		attachmentId: attachment.attachmentId,
	});
	return (
		<a href={url} download={attachment.filename} target="_blank" rel="noopener noreferrer" className="attachment-chip" title={attachment.filename}>
			<IconCmp size={16} className="attachment-chip__icon" />
			<span className="attachment-chip__name">{attachment.filename}</span>
			<span className="attachment-chip__size">{formatBytes(attachment.size)}</span>
		</a>
	);
};

export default AttachmentChip;
